import { BOOK_TYPES, GROUP_BY_COLUMN_DATA } from '../shared/constants';
import nonUsGaapColumnDefinitions from './columnDefinitions/nonUsGaapColumnDefinitions';
import nonUsStatColumnDefinitions from './columnDefinitions/nonUsStatColumnDefinitions';
import usFederalColumnDefinitions from './columnDefinitions/usFederalColumnDefinitions';
import usStateColumnDefinitions from './columnDefinitions/usStateColumnDefinitions';

import historicalNonUsGaapColumnDefinitions from './historicalColumnDefinitions/nonUsGaapColumnDefinitions';
import historicalNonUsStatColumnDefinitions from './historicalColumnDefinitions/nonUsStatColumnDefinitions';
import historicalUsFederalColumnDefinitions from './historicalColumnDefinitions/usFederalColumnDefinitions';
import historicalUsStateColumnDefinitions from './historicalColumnDefinitions/usStateColumnDefinitions';

const HISTORICAL_COLUMN_DEFINITIONS_BY_BOOK_TYPE = {
  [BOOK_TYPES.US_FED]: historicalUsFederalColumnDefinitions,
  [BOOK_TYPES.US_STATE]: historicalUsStateColumnDefinitions,
  [BOOK_TYPES.TED_NON_US_GAAP]: historicalNonUsGaapColumnDefinitions,
  [BOOK_TYPES.TED_NON_US_STAT]: historicalNonUsStatColumnDefinitions,
};

const COLUMN_DEFINITIONS_BY_BOOK_TYPE = {
  [BOOK_TYPES.US_SUMMARY]: usFederalColumnDefinitions,
  [BOOK_TYPES.US_FED]: usFederalColumnDefinitions,
  [BOOK_TYPES.US_STATE]: usStateColumnDefinitions,
  [BOOK_TYPES.TED_NON_US_GAAP]: nonUsGaapColumnDefinitions,
  [BOOK_TYPES.TED_NON_US_STAT]: nonUsStatColumnDefinitions,
};

const getColumnDefs = (
  reportBookType,
  groupType,
  groupItem,
  {
    hasSourceCurrency = false,
    useHistorical = false,
    shouldDisplayZero,
    hideDecimals,
    negativeMinus,
  }
) => {
  const columnDefinition = useHistorical
    ? (
      HISTORICAL_COLUMN_DEFINITIONS_BY_BOOK_TYPE[reportBookType]
      || HISTORICAL_COLUMN_DEFINITIONS_BY_BOOK_TYPE[BOOK_TYPES.TED_NON_US_GAAP]
    )
    : (
      COLUMN_DEFINITIONS_BY_BOOK_TYPE[reportBookType]
      || COLUMN_DEFINITIONS_BY_BOOK_TYPE[BOOK_TYPES.TED_NON_US_GAAP]
    );

  const groupByColumnData = GROUP_BY_COLUMN_DATA[groupType] || GROUP_BY_COLUMN_DATA.BU;

  return columnDefinition({
    ...groupByColumnData,
    groupItem: groupItem && groupItem !== 'ALL' ? groupItem : null,
    hasSourceCurrency,
    shouldDisplayZero,
    hideDecimals,
    negativeMinus,
  });
};

export default getColumnDefs;
